export default __webpack_public_path__ + "static/media/color-background.186ca139.svg";